/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 9b885131a012
 */

import * as z from "zod";

/**
 * The asset relation request.
 */
export type RelateAssetsByAssetIdRequest = { assets_to_relate: Array<string> };

export const RelateAssetsByAssetIdRequest$zodSchema: z.ZodType<
  RelateAssetsByAssetIdRequest
> = z.object({
  assets_to_relate: z.array(z.string()).describe(
    "Relates the asset to all the assets specified in this array of up to 10 assets, specified by their asset IDs.",
  ),
}).describe("The asset relation request.");
